/**
 * Teste le support du popover natif.
 * @return {boolean} true si supporté
 */
function isPopoverSupported() {
  return (
    typeof HTMLElement !== 'undefined' &&
    typeof HTMLElement.prototype === 'object' &&
    'popover' in HTMLElement.prototype
  );
}

if (!isPopoverSupported()) {
  /**
   * Ajoute la propriété `popoverTargetElement` aux éléments ayant l'attribut `popovertarget`.
   * L'attribut est quand même présent, mais il faut récupérer l'élément pointé pour l'ajouter à l'objet du DOM.
   */
  function addPopoverTargetElement() {
    document.querySelectorAll('[popovertarget]').forEach((popover) => {
      if (!popover.popoverTargetElement) {
        popover.popoverTargetElement = document.getElementById(popover.getAttribute('popovertarget'));
      }
    });
  }

  /**
   * Ajoute les fonctions d'affichage du popover : `togglePopover`, `showPopover` et `hidePopover`.
   */
  function addPopoverFunctions() {
    document.querySelectorAll('[popover]').forEach((popover) => {
      if (!Object.hasOwn(popover, 'togglePopover')) {
        popover.togglePopover = function() {
          togglePopover(popover);
        }
      }
      if (!Object.hasOwn(popover, 'showPopover')) {
        popover.showPopover = function() {
          togglePopover(popover, 'open');
        }
      }
      if (!Object.hasOwn(popover, 'hidePopover')) {
        popover.hidePopover = function() {
          togglePopover(popover, 'closed');
        }
      }
    });
  }

  /**
   * Ajoute un Gestionnaire au click sur le popover.
   */
  function addPopoverToggleHandlers() {
    const popoverToggleButtons = document.querySelectorAll('[popovertarget]');
    popoverToggleButtons.forEach((button) => {
      button.addEventListener('click', togglePopoverHandler);
    });
  }

  /**
   * Initialise les popovers.
   */
  function initPopovers() {
    addPopoverTargetElement();
    addPopoverFunctions();
    addPopoverToggleHandlers();
  }

  /**
   * Gestionnaire du click.
   * @param {Event} event
   */
  function togglePopoverHandler(event) {
    togglePopover(event.currentTarget.popoverTargetElement, event.currentTarget.getAttribute('popovertargetaction'));
  }



  document.querySelector('html').classList.add('legacy-support-no-popover');
  initPopovers();
  document.addEventListener('readystatechange', () => {
    if (document.readyState === 'complete') {
      initPopovers();
    }
  });

  const body = document.querySelector('body');
  const mutationObserver = new MutationObserver(initPopovers);
  mutationObserver.observe(body, {childList: true, subtree: true, attributes: false});
}

function iOS() {
  return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

if (iOS() && isPopoverSupported()) {
  document.addEventListener('readystatechange', () => {
    if (document.readyState === 'complete') {
      document.querySelector('html').classList.add('legacy-support-webkit-popover');
      addEventToPopoverButtonsInForm();
      const body = document.querySelector('body');
      const mutationObserver = new MutationObserver(addEventToPopoverButtonsInForm);
      mutationObserver.observe(body, {childList: true, subtree: true, attributes: false});
    }
  });

  /**
   * Ajoute le gestionnaire de click venant prendre en charge le popover.
   */
  function addEventToPopoverButtonsInForm() {
    document.querySelectorAll('button[popovertarget]').forEach((b) => {
      const targetElement = document.getElementById(b.getAttribute('popovertarget'));
      targetElement.addEventListener('beforetoggle', (event) => {
        targetElement.classList.toggle('legacy-support-no-popover--open', event.newState === 'open');
      });
      b.removeEventListener('click', handlePopoverWebkit);
      b.addEventListener('click', handlePopoverWebkit);
    });
  }

  /**
   * Traite l'action du popover.
   * @param {Event} event
   */
  function handlePopoverWebkit(event) {
    const b = event.currentTarget;
    const targetElement = document.getElementById(b.getAttribute('popovertarget'));
    if (b.getAttribute('popovertargetaction') === 'show') {
      togglePopover(targetElement, 'open');
    } else if (b.getAttribute('popovertargetaction') === 'hide') {
      togglePopover(targetElement, 'closed');
    } else {
      togglePopover(targetElement);
    }
  }
}

/**
 * Bascule le popover.
 * @param {HTMLElement} popoverTargetElement la cible du popover
 * @param {('open'|'closed'|null)} [force] force l'ouverture ou la fermeture
 */
function togglePopover(popoverTargetElement, force) {
  let newState;
  if (['open', 'closed'].includes(force)) {
    newState = force;
  } else {
    newState = popoverTargetElement.classList.contains('legacy-support-no-popover--open') ? 'closed' : 'open';
  }
  dispatchEvents(popoverTargetElement, 'beforetoggle', newState);
  popoverTargetElement.classList.toggle('legacy-support-no-popover--open', newState === 'open');
  dispatchEvents(popoverTargetElement, 'toggle', newState);
}

/**
 * Envoie un événements sur la cible du popover
 * @param {HTMLElement} popoverTargetElement cible
 * @param {('toggle'|'beforetoggle')} eventName nom de l'événement
 * @param {('open'|'closed')} newState état à notifier
 */
function dispatchEvents(popoverTargetElement, eventName, newState) {
  const event = new Event(eventName);
  event.newState = newState;
  popoverTargetElement.dispatchEvent(event);
}
